import React from "react";
import { Button } from "react-bootstrap";
import Modal from "../../common/components/ThemedModal";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch } from "../../../store/hooks";
import { setShowLoginModal } from "../../../store/slices/userSlice";

interface SignInToCreateLeagueModalProps {
	show: boolean;
	onHide: () => void;
}

const SignInToCreateLeagueModal: React.FC<SignInToCreateLeagueModalProps> = ({
	show,
	onHide,
}) => {
	const dispatch = useAppDispatch();

	const handleSignIn = () => {
		dispatch(setShowLoginModal(true));
		onHide();
	};

	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>Sign In Required</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>You must be signed in to create a league.</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="primary" onClick={handleSignIn}>
					Sign In
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default SignInToCreateLeagueModal;
